import React, { useState, useEffect } from "react";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import styles from './styles/Login.module.css';

const Login = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/home", { replace: true });
    }
  }, [navigate]);

  const [usuario, setUsuario] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');

  const [isCapsLockOn, setIsCapsLockOn] = useState(false);

  const handleKeyUp = (event) => {
    // Verifica se a tecla Caps Lock está ativa
    const isCapsLockActive = event.getModifierState('CapsLock');
    setIsCapsLockOn(isCapsLockActive);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post('https://provin.ind.br/api/login', { usuario, senha });

      // Salva o token e o nome de usuário no localStorage
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('usuarioId', response.data.usuarioId);
      localStorage.setItem('usuario', response.data.usuario);
      localStorage.setItem('permissoes', JSON.stringify(response.data.permissoes));

      // Redireciona para a página home
      navigate('/home');
    } catch (error) {
      setErro('Credenciais Inválidas!');
    }
  };

  return (
    <div className={styles.body}>
      <div className={styles.container}>
        <img src="images/common/provin_joias.ico" alt="logo" />
        <h2>Provin Joias</h2>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Usuário ou E-mail"
            value={usuario}
            onChange={(e) => setUsuario(e.target.value)}
            required
          />

          <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
            <input
              type="password"
              placeholder="Senha"
              onKeyUp={handleKeyUp}
              onBlur={() => setIsCapsLockOn(false)}
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              required
            />

            {isCapsLockOn && (
              <div style={{
                position: 'absolute',
                top: '-40px', // Posiciona acima do input
                right: '10px', // Fixa no canto direito do input
                backgroundColor: '#fefefe',
                color: '#333',
                padding: '8px 12px',
                borderRadius: '5px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                fontSize: '0.9em',
                zIndex: 1000,
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                whiteSpace: 'nowrap' // Evita que o texto quebre em várias linhas
              }}>
                <span role="img" aria-label="aviso">⚠️</span> Caps Lock ligado!
                <div style={{
                  position: 'absolute',
                  bottom: '-8px',
                  right: '10px',
                  width: '0',
                  height: '0',
                  borderLeft: '8px solid transparent',
                  borderRight: '8px solid transparent',
                  borderTop: '8px solid #fefefe'
                }} />
              </div>
            )}
          </div>

          {erro && <p>{erro}</p>}

          <button type="submit">Entrar</button>
        </form>
      </div>
    </div>
  );
};

export default Login;